import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getMarketplaceBackend } from '../../config/appConfig';
import { accessToken } from '../../../../configuration/tokenHandling/accessToken';
import type { BookingIntent } from './types';
import { mapBookingIntentsResponse } from './bookingIntentMapper';

export const bookingIntentApiSlice = createApi({
    reducerPath: 'bookingIntentApi',
    baseQuery: fetchBaseQuery({
        baseUrl: getMarketplaceBackend(),
        prepareHeaders: headers => {
            const token = accessToken.getAccessToken();
            if (token) {
                headers.set('Authorization', `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: builder => ({
        getBookingIntentsByVin: builder.query<BookingIntent[], string>({
            query: vin =>
                `${getMarketplaceBackend()}/package-service/admin/booking-intents?vin=${encodeURIComponent(vin)}`,
            // biome-ignore lint/suspicious/noExplicitAny: RTK Query transform response typing is loose here
            transformResponse: (response: any) => mapBookingIntentsResponse(response),
        }),
    }),
});

export const { useLazyGetBookingIntentsByVinQuery } = bookingIntentApiSlice;
